<script>

import errorsMixin from '@/mixins/errors.mixin'
export default {
  mixins: [errorsMixin],
  props: {
    formErrors: Object
  },
  
  render() {
    return this.$scopedSlots.default({
      formErrors: this.formErrors,
      checkValidatorBeforeSend: this.checkValidatorBeforeSend,
      formData: this.formData,
      send: this.send
    })
  },

  inject: ['svc'],

  data:() => ({
    processing: false,
    formData: {
      city: '',
      date: '',
      notes: '',
      name: '',
      isVisibleOnLanding: true,
    }
  }),

  methods: {
    toggle() {
      this.updateShowing(!this.showing)
    },

    checkValidatorBeforeSend(payload) {
      this.send(payload)
    },

    async send({data}) {
      try {
        this.processing = true
        let res = await this.svc.createCourse(data)
        this.$emit('create', res)
        this.$notify({text: 'Course created', type: 'success'})
        this.$emit('end')
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.processing = false
      }
    }
  }
}
</script>